import React from 'react';

export function StarIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
      <path
        d="M3.5 6C3.5 5.33696 3.76339 4.70107 4.23223 4.23223C4.70107 3.76339 5.33696 3.5 6 3.5C5.33696 3.5 4.70107 3.23661 4.23223 2.76777C3.76339 2.29893 3.5 1.66304 3.5 1C3.5 1.66304 3.23661 2.29893 2.76777 2.76777C2.29893 3.23661 1.66304 3.5 1 3.5C1.66304 3.5 2.29893 3.76339 2.76777 4.23223C3.23661 4.70107 3.5 5.33696 3.5 6Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
